import {
  APPLY_LEAVE_REQUEST,
  APPLY_LEAVE_SUCCESS,
  APPLY_LEAVE_FAILURE,
} from "../actions/applyLeaveActions";

const initialState = {
  loading: false,
  success: false,
  error: null,
  appliedLeave: null,
};

const applyLeaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPLY_LEAVE_REQUEST:
      return { ...state, loading: true, success: false, error: null };
    case APPLY_LEAVE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        appliedLeave: action.payload,
      };
    case APPLY_LEAVE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };
    default:
      return state;
  }
};

export default applyLeaveReducer;
